import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  signInStart,
  signInSuccess,
  signInFailure,
} from "../redux/user/userSlice";
import OAuth from "../components/OAuth";

// import { useCookies } from "react-cookie";

export default function SignIn() {
  // const [cookies, setCookie, removeCookie] = useCookies(["access_token"]);
  const [formData, setFormData] = useState({});
  const { loading, error } = useSelector((state) => state.user);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.id]: e.target.value,
    });
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      dispatch(signInStart());
      const res = await fetch("/api/auth/signin", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          // Accept: "application/json",
          // "Access-Control-Allow-Origin": "https://migoloo-api.vercel.app",
          // "Access-Control-Allow-Origin": "http://localhost:3000",
        },
        credentials: "include",
        body: JSON.stringify(formData),
      });
      //Test
      // .then((res) => {
      //   console.log(res.headers.get("access_token")); // undefined
      //   console.log(document.cookie); // nope
      //   return res.json();
      // });

      // console.log("ccc", res.headers);
      // console.log("aaa", res.headers.get("set-cookie")); // undefined
      // console.log("bbb", document.cookie); // nope

      //End of Test
      const data = await res.json();
      console.log(data);
      if (data.success === false) {
        dispatch(signInFailure(data.message));
        return;
      }
      dispatch(signInSuccess(data));
      navigate("/");
    } catch (error) {
      dispatch(signInFailure(error.message));
    }
  };
  return (
    <div className="p-3 max-w-lg mx-auto">
      <h2 className="text-3xl text-center font-semibold my-7">Sign In</h2>
      <form onSubmit={handleSubmit} className="flex flex-col gap-4">
        <input
          type="email"
          placeholder="email"
          className="border p-3 rounded-lg"
          id="email"
          onChange={handleChange}
        />
        <input
          type="password"
          placeholder="password"
          className="border p-3 rounded-lg"
          id="password"
          onChange={handleChange}
        />

        <button
          disabled={loading}
          className="bg-slate-700 text-white p-3 rounded-lg uppercase hover:opacity-95 disabled:opacity-80"
        >
          {loading ? "Loading..." : "Sign In"}
        </button>
        {/* <OAuth /> */}
      </form>
      <div className="xs:flex-col sm:flex gap-2 mt-5 justify-between">
        <div>
          <span>Dont have an account?</span>
          <Link to={"/sign-up"}>
            <span className="text-blue-700"> Sign up</span>
          </Link>
        </div>
        <div className="">
          <Link to={"/forgetpwd"}>
            <span className="text-blue-500">Forgotten password</span>
          </Link>
        </div>
      </div>
      {error && <p className="text-red-500 mt-5">{error}</p>}
    </div>
  );
}
